// ==========================================================================
// Frame2 — Hiệu ứng vòng quay may mắn (promotion)
// Dùng module libraryMainsite.promotion. Nút .pm__rut[data-value] là hook click
// do lib tự bind; ở đây ta cấu hình animation chạy sáng quanh các .effect__item.
// Config phần thưởng nằm ở biến prodTemplate (assets/main/html/configProduction).
// ==========================================================================

// Bộ đếm thời gian cho mỗi bước nhảy sáng
class Core {
	constructor() {
		this.currentTimeout = null;
	}
	wait(timeout) {
		if (this.currentTimeout) clearTimeout(this.currentTimeout);
		return new Promise((resolve) => {
			this.currentTimeout = setTimeout(resolve, timeout);
		});
	}
}

var currentPool;
window.currentPool = currentPool;

window.addEventListener("load", function () {
	const dndPromotion = window.libraryMainsite.promotion;

	// Chạy sáng ngẫu nhiên nhanh -> chậm dần -> dừng đúng ô trúng, giữ nguyên
	// đến khi callback reset. Đếm nội bộ (không dùng biến global) để callback của
	// lib không chen vào làm reset bộ đếm giữa chừng -> vòng quay luôn dừng đúng.
	async function animationRandom(steps, elementResult) {
		const listItem = $(".effect__item");
		const core = new Core();
		// elementResult = indexImg lib trả về = tên phần thưởng (vd "prize-06"),
		// trùng khít class trên ô -> match bằng class (không so data-stt số gây lệch kiểu).
		const winner = listItem.filter(function () {
			return this.classList.contains(elementResult);
		});

		for (let i = 0; i < steps; i++) {
			listItem.removeClass("MS__active").addClass("MS__off");
			const remaining = steps - 1 - i;

			// Bước cuối: sáng đúng ô trúng; các bước trước: sáng ngẫu nhiên.
			const target = remaining === 0 ? winner : $(listItem[Math.floor(Math.random() * listItem.length)]);
			target.removeClass("MS__off").addClass("MS__active");

			// Giảm tốc dần ở ~4 bước cuối để mắt kịp bám theo, dừng mượt ở ô trúng.
			const delay = remaining > 3 ? 150 : 150 + (4 - remaining) * 140;
			await core.wait(delay);
		}
		// Kết thúc: ô trúng vẫn giữ MS__active tới khi callback dọn class.
	}

	dndPromotion({
		url: prodTemplate.url,
		debug: prodTemplate.debug,
		directory: prodTemplate.directory,
		items: prodTemplate.items,
		names: prodTemplate.names,
		config: {
			// Phải >= tổng thời gian animationRandom (~2760ms do đã giảm tốc bước cuối)
			// để popup kết quả bung SAU khi vòng quay dừng ở ô trúng.
			timeWait: 2900,
		},
		// Có kết quả -> chạy hiệu ứng dừng ở phần thưởng trúng
		animResult: function (listPrize) {
			const displayPrize = listPrize[0];
			const prizeIndex = displayPrize.indexImg;
			animationRandom(10, prizeIndex);
		},
		// Reset trạng thái sau mỗi lượt quay
		callback: function () {
			if (typeof prodTemplate.fnPromotion === "function") prodTemplate.fnPromotion();
			$(".effect__item").removeClass("MS__active").removeClass("MS__off");
		},
	});
});
